@let settingsValue = settings();
@let radarDtgValue = radarDtg();

@if (radarDtgValue) {
  @let radarZoomLevelValue = radarZoomLevel();
  @let activeRadarFrameValue = activeRadarFrame;
  @let isActiveRadarFrameFcstValue = isActiveRadarFrameFcst;
  @let activeRadarFramePositionPercentValue = activeRadarFramePositionPercent;

  <div class="dashboard-radar-map-wrapper">
    <mgl-map
      [style]="'mapbox://styles/' + mapService.getActiveMapLayer()['style']"
      [accessToken]="mapboxAccessToken"
      [zoom]="[radarZoomLevelValue]"
      [center]="getMapCenter(settingsValue['zoomPoint'], radarZoomLevelValue)"
      [interactive]="false"
      [attributionControl]="false"
      [logoPosition]="'top-left'"
      (mapCreate)="onMapCreate($event)">
      @for (
        frame of radarAnimationFrames();
        track frame.slider;
        let i = $index
      ) {
        <mgl-raster-source
          [id]="'radar-source-' + i"
          [tiles]="[getRadarTileUrl(frame)]"
          [tileSize]="1024"
          [bounds]="radarProjections[settingsValue['region']]"
          [maxzoom]="4">
        </mgl-raster-source>

        <mgl-layer
          [id]="'radar-layer-' + i"
          [source]="'radar-source-' + i"
          type="raster"
          [paint]="{
            'raster-opacity': i === activeRadarFrameIndex() ? 1 : 0,
            'raster-opacity-transition': { duration: 0 },
          }">
        </mgl-layer>
      }

      @let radarCircleGeometryValue = radarCircleGeometry();
      @if (radarZoomLevelValue > 4 && radarCircleGeometryValue.length > 0) {
        <!-- distance circles -->
        @for (i of [0, 1, 2]; track $index) {
          <mgl-geojson-source [id]="'circle' + i">
            <mgl-feature [geometry]="radarCircleGeometryValue[i]"></mgl-feature>
          </mgl-geojson-source>
          <mgl-layer
            [id]="'circle' + i"
            type="line"
            [source]="'circle' + i"
            [paint]="radarCirclePaint">
          </mgl-layer>
        }
      }
    </mgl-map>

    <div class="radar-animation-overlay">
      <button
        type="button"
        class="radar-animation-button"
        (click)="toggleRadarAnimation($event)"
        [attr.aria-label]="
          isRadarAnimationPlaying()
            ? 'Radar Animation pausieren'
            : 'Radar Animation starten'
        ">
        <fa-icon [icon]="['fas', isRadarAnimationPlaying() ? 'pause' : 'play']">
        </fa-icon>
      </button>

      <span
        class="radar-animation-time"
        [class.radar-animation-time--fcst]="isActiveRadarFrameFcstValue">
        {{ activeRadarFrameValue | datex: 'HH:mm' }}
      </span>

      <div class="radar-animation-progress">
        @for (frame of radarAnimationFrames(); track $index; let i = $index) {
          <span
            class="radar-animation-progress-dot"
            role="button"
            tabindex="0"
            [attr.aria-label]="'Zu ' + getFrameTime(frame) + ' springen'"
            [class.radar-animation-progress-dot--fcst]="frame.isFcst"
            (click)="selectRadarFrame(i, $event)"
            (keydown.enter)="selectRadarFrame(i, $event)"
            (keydown.space)="selectRadarFrame(i, $event)">
          </span>
        }

        <span
          class="radar-animation-current-marker"
          [class.radar-animation-current-marker--fcst]="
            isActiveRadarFrameFcstValue
          "
          [style.left.%]="activeRadarFramePositionPercentValue"
          aria-hidden="true">
        </span>
      </div>
    </div>
  </div>
} @else {
  <app-loading-overlay text="Daten werden geladen..." [fullScreen]="false">
  </app-loading-overlay>
}
